import Tag from '@space-core/components/tag'
import useTranslation from '@space-core/hooks/useTranslation'
import LockIcon from '@space-shell/common/components/lockIcon'

import type { Module } from '@space-shell/common/services/sections'
import styled from 'styled-components'

type TagsContainerProps = {
  module: Module
  className?: string
}

const ContentTag = styled.span`
  position: inherit;
  right: var(--spacer-3);
`
const ContentLock = styled.span`
  position: inherit;
  left: var(--spacer-3);
`

const TagsContainer = ({ module }: TagsContainerProps) => {
  const { publicModule, purchased } = module
  const { t } = useTranslation()

  const getModuleType = () => {
    //TODO: add logic for extra and extra paid module
    return 'free'
  }

  return (
    <>
      <ContentTag className='_position-inherit'>
        {publicModule && (
          <Tag
            className='tag-module'
            size='sm'
            {...(publicModule && { variation: 'green' })}
            role='term'>
            {t(`home.modules_in_showcase.module_types.${getModuleType()}`)}
          </Tag>
        )}
      </ContentTag>
      {!publicModule && !purchased && (
        <ContentLock>
          <LockIcon />
        </ContentLock>
      )}
    </>
  )
}

export default TagsContainer
